module.exports = __webpack_public_path__ + "assets/img/14_1084.f85d17c7.jpg";